import { PhotosLinkedToAssetEvent } from '../event/photos-linked-to-asset.event';
const photosLinkedToAssetProjections = {
    [PhotosLinkedToAssetEvent.name]: (event, state) => ({
        ...state,
    }),
};
export default photosLinkedToAssetProjections;
//# sourceMappingURL=photos-linked-to-asset.projection.js.map